import { Injectable } from '@angular/core';
import { CVApiService } from './services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class FeaturesService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    /**
     * Checks if a feature is enabled for the logged in company.
     * @param featureName The name of the feature to check
     * @returns boolean value indicating if the feature is enabled
     */
    async isFeatureEnabled(featureName: string): Promise<boolean> {
        try {
            let response = await this.cvApiService.get<boolean>(`/api/v2/feature-available/${featureName}`);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            }
            else {
                throw response;
            }
        }
        catch (err) {
            console.error(`Failed to retrieve feature ${featureName}.`);
            throw err;
        }
    }
}
